export function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function nl2p(string) {
  return (
    "<p>" +
    string.replace(/\n([ \t]*\n)+/g, "</p><p>").replace("\n", "<br />") +
    "</p>"
  );
}
